import React, { Component } from 'react';
import {
    Row,
    Col,
    Button
} from "reactstrap";
import { authenticationService } from '_services';
import { handleResponse } from '_helpers';
class TSList extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            renderItem: []
            /*
            name: props.name,
            placeholder: props.placeholder,
            isFocus: false,
            value: '',
            icon: props.icon
            */
        };

        this.setFocus = this.setFocus.bind(this);
        //this.handleChange = this.handleChange.bind(this);
    }

    setFocus(e) {
        this.setState(state => ({
            isFocus: e
        }));
    }

    handleChange = event => {
        this.setState({ value: event.target.value });
        if (this.props.onChange)
            this.props.onChange(event);
    };

    componentDidMount() {
        const currentUser = authenticationService.currentUserValue;
        
        if (currentUser) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                }
            };

            fetch('/api/v1/mytele', requestOptions)
                //.then(response => response.json())
                .then(handleResponse)
                .then(
                    (result) => {
                        //console.log(result.data);
                        this.setState({ renderItem: result.data });
                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }

        
    }
    /*
    handleChange(event) {

        this.setState({ value: event.target.value });
        if (this.props.onChange)
            this.props.onChange(event);
    }
    */
    render() {

        const content = this.state.renderItem.map((post) =>
            <Row key={post.teleID} style={{ fontSize: '1em', padding: '10px 10px', borderBottom: '1px solid #dddddd' }}>
                <Col md="3" xs="6">
                    {post.appointDatetimeText}
                </Col>
                <Col md="2" xs="6">
                    {post.serviceTypeName}
                </Col>
                <Col md="3" xs="12">
                    {post.flowStatusName}
                </Col>
                <Col md="4" xs="12">
                    <Button color="primary" size="sm" >
                        <i className="fas fa-file-prescription"></i> <a href="/vdocall" className="navbar-item">Call</a>
                    </Button>
                    <Button color="primary" size="sm" >
                        <i className="fas fa-file-prescription"></i> ยา
                    </Button>

                    <Button color="primary" size="sm">
                        <i className="fas fa-money-bill-wave"></i> ชำระเงิน
                    </Button>

                    <Button color="primary" size="sm">
                        <i className="fas fa-ambulance"></i> จัดส่ง
                    </Button>

                </Col>
            </Row>
        );

        return (
            <div /*style={{ backgroundColor: '#2ca8ff1f' }}*/>
                <Row style={{ fontWeight: 'bold', fontSize: '1em', padding: '10px 10px', borderBottom: '2px solid #dddddd' }}>
                    <Col md="3" xs="6" className="d-none d-sm-block">
                        วันที่นัด
                    </Col>
                    <Col md="2" xs="6" className="d-none d-sm-block">
                        ประเภท
                    </Col>
                    <Col md="3" xs="12" className="d-none d-sm-block">
                        สถานะ
                    </Col>
                    <Col md="4" xs="12" className="d-none d-sm-block">
                        จัดการ
                    </Col>
                </Row>
                {content}
             </div>
        );
    }
}
export default TSList;